import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VesselComponent } from './vessel.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    VesselComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule
  ]
})
export class VesselModule { }
